import { Check } from "lucide-react";
import clsx from "clsx";

interface StepProps extends React.ComponentProps<"li"> {
  label: string;
  current: boolean;
  completed: boolean;
  upcoming: boolean;
  isLast: boolean;
}

export default function Step({
  completed,
  current,
  isLast,
  label,
  upcoming,
}: StepProps) {
  return (
    <li className={clsx("relative", { "pr-8 sm:pr-20": !isLast })}>
      <div className="absolute inset-0 flex items-center" aria-hidden="true">
        <div
          className={clsx("h-0.5 w-full", {
            "bg-purple-600": completed,
            "bg-gray-200": !completed,
          })}
        />
      </div>

      <div
        className={clsx(
          "relative flex h-8 w-8 items-center justify-center rounded-full",
          {
            "bg-purple-600 hover:bg-purple-700": completed,
            "border-2 border-purple-600 bg-white": current,
            "border-2 border-gray-300 bg-white": upcoming,
          }
        )}
        aria-current={current ? "step" : undefined}
      >
        {completed && (
          <Check className="h-5 w-5 text-white" aria-hidden="true" />
        )}

        {current && (
          <span
            className="h-2.5 w-2.5 rounded-full bg-purple-600"
            aria-hidden="true"
          />
        )}

        <span className="sr-only">{label}</span>
      </div>

      <span className="absolute left-1/2 -translate-x-1/2 mt-3 text-xs font-medium text-gray-500">
        {label}
      </span>
    </li>
  );
}
